module.exports = __webpack_public_path__ + "img/trash_only.295b4f4a.svg";